<template>
	<div>
		<router-view></router-view>
		
		<upload ref="upload"></upload>
		<div style="display: none;">
			<button ref="clipboard" id="clipboard" data-clipboard-action="copy" :data-clipboard-text="clipboardText"></button>
		</div>
	</div>
</template>

<script>
	import upload from '@/components/public/upload.vue'
	import clipboard from '@/assets/script/lib/clipboard.js'
	import global from '@/assets/script/function.js'
	import {mapState} from 'vuex'
	
	export default {
		components: {
			upload
		},
		
		data() {
			return {
				clipboardText: ''
			}
		},
		
		computed: {
			...mapState(['theme', 'userInfo', 'systemConfig']),
		},
		
		watch: {
			theme() {
				window.document.documentElement.setAttribute('data-theme', this.theme);
			},
			
			userInfo() {
				this.resetSubmodule();
			},
			
			systemConfig() {
				this.updateWebInfo();
			},
			
			'systemConfig.oms_system_name'() {
				this.updateWebTitle();
			}
		},
		
		created() {
			this.updateWebTitle();
			this.updateWebInfo();
			this.$store.dispatch('getSystemConfig');
			window.document.documentElement.setAttribute('data-theme', this.theme);
		},
		
		mounted() {
			new clipboard('#clipboard').on('success', e => {
				this.$message({
					text: '复制成功'
				});
			}).on('error', e =>{
				this.$message({
					text: '该浏览器不支持复制',
					icon: 'fail'
				});
			});
		},
		
		methods: {
			updateWebTitle() {
				document.title = this.systemConfig.oms_system_name || '运营管理平台';
			},
			
			updateWebInfo() {
				let ico = document.querySelector('link[rel="shortcut icon"]');
				if (ico) {
					ico.href = this.systemConfig.oms_favicon
				} else {
					var head = document.getElementsByTagName('head')[0];
					var link = document.createElement('link');
					link.rel = 'shortcut icon';
					link.href = this.systemConfig.oms_favicon;
					head.appendChild(link);
				}
			},
			
			upload(opt) {
				this.$refs.upload.upload(opt);
			},
			
			clipboard(text) {
				this.clipboardText = text;
				this.$nextTick(() => {
					this.$refs.clipboard.click();
				});
			}
		}
	};
</script>

<style lang="stylus">
	@import './assets/style/reset';
	@import './assets/style/fonts';
	@import './assets/style/mobile';

	/* animation */
	.an {
		animation-fill-mode: forwards !important;

		&-fadein {
			opacity: 0;
			animation: fadeIn 0.4s;
		}

		&-fadeout {
			opacity: 1;
			animation: fadeOut 0.2s;
		}

		&-bounce {
			transform: scale(0.5);
			animation: bounce 0.4s;
		}
	}

	@keyframes bounce {
		0% {
			transform: scale(0.5);
		}

		100% {
			transform: scale(1);
		}
	}

	@keyframes fadeIn {
		0% {
			opacity: 0;
		}

		100% {
			opacity: 1;
		}
	}

	@keyframes fadeOut {
		0% {
			opacity: 1;
		}

		100% {
			opacity: 0;
		}
	}
	/* end animation */

	/* public */
	body {
		background: #F5F5F5;
	}
	
	.s-link {
		color: #003DD9;
	}

	.cover-layer {
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.6);
		z-index: 101;

		&.invisible {
			opacity: 0;
		}
	}
	
	.ellipsis {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.ellipsis-2,
	.ellipsis-3,
	.ellipsis-n {
		display: -webkit-box;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: initial;
		-webkit-box-orient: vertical;
	}
	.ellipsis-2 {
		-webkit-line-clamp: 2;
	}
	.ellipsis-3 {
		-webkit-line-clamp: 3;
	}
	/* end public */

	/* flex */
	.flex {
		display: flex;
		flex-direction: row;

		&-start {
			display: flex;
			justify-content: flex-start;
			align-items: flex-start;

			&-main {
				display: flex;
				justify-content: flex-start;
				align-items: stretch;
			}
			&-cross {
				display: flex;
				justify-content: flex-start;
				align-items: flex-start;
			}
			&-center {
				display: flex;
				justify-content: flex-start;
				align-items: center;
			}
			&-end {
				display: flex;
				justify-content: flex-start;
				align-items: flex-end;
			}
			&-baseline {
				display: flex;
				justify-content: flex-start;
				align-items: baseline;
			}
			&-stretch {
				display: flex;
				justify-content: flex-start;
				align-items: stretch;
			}
		}

		&-center {
			display: flex;
			justify-content: center;
			align-items: center;

			&-main {
				display: flex;
				justify-content: center;
				align-items: stretch;
			}
			&-cross {
				display: flex;
				justify-content: flex-start;
				align-items: center;
			}
			&-start {
				display: flex;
				justify-content: center;
				align-items: flex-start;
			}
			&-end {
				display: flex;
				justify-content: center;
				align-items: flex-end;
			}
			&-baseline {
				display: flex;
				justify-content: center;
				align-items: baseline;
			}
			&-stretch {
				display: flex;
				justify-content: center;
				align-items: stretch;
			}
		}

		&-end {
			display: flex;
			justify-content: flex-end;
			align-items: flex-end;

			&-main {
				display: flex;
				justify-content: flex-end;
				align-items: stretch;
			}
			&-cross {
				display: flex;
				justify-content: flex-start;
				align-items: flex-end;
			}
			&-start {
				display: flex;
				justify-content: flex-end;
				align-items: flex-start;
			}
			&-center {
				display: flex;
				justify-content: flex-end;
				align-items: center;
			}
			&-baseline {
				display: flex;
				justify-content: flex-end;
				align-items: baseline;
			}
			&-stretch {
				display: flex;
				justify-content: flex-end;
				align-items: stretch;
			}
		}

		&-between {
			display: flex;
			justify-content: space-between;

			&-start {
				display: flex;
				justify-content: space-between;
				align-items: flex-start;
			}
			&-center {
				display: flex;
				justify-content: space-between;
				align-items: center;
			}
			&-end {
				display: flex;
				justify-content: space-between;
				align-items: flex-end;
			}
			&-baseline {
				display: flex;
				justify-content: space-between;
				align-items: baseline;
			}
			&-stretch {
				display: flex;
				justify-content: space-between;
				align-items: stretch;
			}
		}

		&-around {
			display: flex;
			justify-content: space-around;

			&-start {
				display: flex;
				justify-content: space-around;
				align-items: flex-start;
			}
			&-center {
				display: flex;
				justify-content: space-around;
				align-items: center;
			}
			&-end {
				display: flex;
				justify-content: space-around;
				align-items: flex-end;
			}
			&-baseline {
				display: flex;
				justify-content: space-around;
				align-items: baseline;
			}
			&-stretch {
				display: flex;
				justify-content: space-around;
				align-items: stretch;
			}
		}

		&-stretch {
			display: flex;
			align-items: stretch;
		}

		&-baseline {
			display: flex;
			align-items: baseline;
		}

		&-column {
			display: flex;
			flex-direction: column;

			&-reverse {
				display: flex;
				flex-direction: row-reverse;
			}

			> .flex-grow {
				width: initial;
				height: 0;
				
				&-auto {
					width: initial;
					height: auto;
				}
			}
		}
		&-reverse {
			display: flex;
			flex-direction: row-reverse;
		}

		&-wrap {
			display: flex;
			flex-wrap: wrap;
		}
		&-grow {
			flex-grow: 1;
			width: 0;
			
			&-auto {
				flex-grow: 1;
				width: auto;
			}
		}
		&-shrink {
			flex-shrink: 1;
		}
	}
	/* end flex */
</style>

<style lang="stylus" scoped>
	.m-iframe {
		width: 100%;
		border: none;
	}
</style>